import { Row } from '../../../../../coaching-observation/experimental.grid';
import { PayloadAction } from '../../../../../store.model';
import { ActionType } from '../commitment-narrative.action';
import { CellContext, RowContext } from '../commitment-narrative.model';
import { State } from '../commitment-narrative.state';
import { RowActionType } from '../models/row-action-type.enum';

import { UpdateOrRemoveNote } from './update-row.action';

export function updateOrRemoveNoteReducer(
    state: State,
    action: PayloadAction<ActionType, UpdateOrRemoveNote>,
): State {
    const { id, content, actionType } = action.payload;

    if (actionType === RowActionType.UpdateContent) {
        const updateNotesContent = (
            rows: Array<Row<RowContext, CellContext>>,
        ): Array<Row<RowContext, CellContext>> => {
            return rows.map((row) => {
                if (row.id === id) {
                    const updatedNotes = row.ctx.notes.map((note) => {
                        return { ...note, contents: content };
                    });
                    return { ...row, ctx: { ...row.ctx, notes: updatedNotes } };
                }
                return row;
            });
        };
        return {
            ...state,
            rows: updateNotesContent(state.rows),
            filteredRow: updateNotesContent(state.filteredRow),
        };
    } else if (actionType === RowActionType.Remove) {
        return {
            ...state,
            rows: state.rows.filter((row) => row.id !== id),
            filteredRow: state.filteredRow.filter((row) => row.id !== id),
        };
    }

    return state;
}
